import { useQuery } from "@tanstack/react-query"
import { api } from "../lib/api/client"
import { createQueryKeys } from "../lib/query-keys"

interface User {
  _id: string
  display_name?: string
  given_name?: string
  family_name?: string
  avatar?: string
}

export const userKeys = createQueryKeys("users")

/**
 * Hook to fetch and cache user data by ID
 * Useful for displaying user avatars and names in feeds, comments, etc.
 */
export function useUser(userId: string | undefined) {
  return useQuery({
    queryKey: userKeys.detail(userId ?? ""),
    queryFn: async () => {
      const response = await api.users.findById(userId!)
      return response.data as User
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes - user data rarely changes
  })
}
